import GalleryPortal from "./GalleryPortal"
export default GalleryPortal
